export class QuizModel {
  constructor (data) {
    this._id = (data._id || null)
    this.title = (data.title || 'Questionário')
    if (data.course) {
      this.course = data.course
    }
    if (data.module) {
      this.module = data.module
    }

    if (!data.questions || !data.questions.length) {
      this.questions = [{
        ask: '',
        answers: [
          { text: null, correct: false },
          { text: null, correct: false },
          { text: null, correct: false },
          { text: null, correct: false }
        ]
      }]
    } else {
      this.questions = data.questions
    }
  }
}
